"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = require("@ccw-pwa-ui/Image");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Header = require("@ccw-pwa-ui/Header");
require("../styles/LoginScreenComponentStyle.css");
var _index = _interopRequireDefault(require("../common_features/assets/index"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
const LoginScreenComponent = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-email-main-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-email-header-container"
  }, /*#__PURE__*/_react.default.createElement(_Header.Header, {
    imageUrl: props.headerImage,
    imageStyle: {
      width: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "welcome-user-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-scr email-screen-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "full-height"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-image-container welcome-scr-banner"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: _index.default.welcomeScreenImage.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "banner-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.2',
      marginBottom: '16px',
      fontWeight: 600
    },
    variant: "header-text",
    headerText: props.headerImageText
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      color: '#FFFFFF',
      lineHeight: '1.4',
      fontSize: 20,
      marginBottom: '16px',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.headerImageSubText
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "wellcome-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-logo-container"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    imageStyle: {
      alignSelf: 'left'
    },
    url: _index.default.pentairLogo.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-screen-detail"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "simple-text",
    headerText: props.headerSubText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-password-container ".concat(!props.isEmailValid && props.isEmailTouch ? "invalid-mail" : null)
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: 10,
      display: 'block'
    },
    variant: "header-text",
    headerText: props.emailText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    onBlur: props.handleEmailBlur,
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.emailPlaceholder,
    value: props.email,
    onchange: props.onEmailChange
  }), !props.isEmailValid && props.isEmailTouch ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Please enter a valid email",
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#E00932',
      lineHeight: '22px'
    }
  }) : null, !props.isEmailValid && props.isEmailTouch && /*#__PURE__*/_react.default.createElement("img", {
    src: props.errorImage,
    className: "input-currentwarningIconn"
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: 10,
      display: 'block'
    },
    variant: "header-text",
    headerText: props.passwordText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10
    },
    placeholder: props.passwordSubText,
    inputType: "password",
    value: props.password,
    onchange: props.onPasswordChange
  }), props.errorMessage ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: "18px",
      color: "#E00932"
    }
  }, "This password and email combination does not exist") : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-forgot-password-text"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "forgot-password-text",
    headerText: props.forgotText,
    navigationUrl: props.forgotPasswordUrl,
    target: "_self"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "email-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.signinText,
    onClick: props.onClickSignInButton,
    disabled: !props.isSignInDisabled
  })))))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = LoginScreenComponent;